export function isFileTransfer<E>(event: React.DragEvent<E>): boolean {
  return event.dataTransfer.types?.some((type) => type === 'Files') ?? false
}
